(function($) {
    $.fn.post_json = function(data) {
        $.ajax({
            type: "POST",
            url: data.url,
            data: JSON.stringify(data.data),
            cache: data.setcache === true ? false : true,
            dataType: "json",
            contentType: "application/json",
            xhrFields: {
                withCredentials: true
            },
            success: function(response) {
                if ($.isFunction(data.success)) {
                    data.success(response);
                }
                return null;
            },
            error: function(jqXHR, textStatus, errorThrown) {
                if ($.isFunction(data.error)) {
                    data.error(jqXHR);
                }
                return null;
            }
        });
    };

    $.fn.get_json = function(data) {
        $.ajax({
            type: "GET",
            url: data.url,
            cache: data.setcache === true ? false : true,
            dataType: "json",
            contentType: "application/json",
            xhrFields: {
                withCredentials: true
            },
            success: function(response) {
                if ($.isFunction(data.success)) {
                    data.success(response);
                }
                return null;
            },
            error: function(jqXHR, textStatus, errorThrown) {
                if ($.isFunction(data.error)) {
                    data.error(jqXHR);
                }
                return null;
            }
        });
    };

    /**
     * Serializacja formularza jquery do obiektu
     *
     * @example return objectifyForm(this.serializeArray());
     * @param {*} formArray
     * @returns
     */
    $.fn.objectifyForm = function(formArray) {
        //serialize data function
        var returnArray = {};
        for (var i = 0; i < formArray.length; i++) {
            var item = formArray[i];
            var $el = $('[name="' + item.name + '"]');

            switch ($el.data("type")) {
                case "number":
                    if (!item.value) {
                        continue;
                    }

                    item.value = item.value.indexOf(".") === -1 ? parseInt(item.value) : parseFloat(item.value);
                    break;
                case "boolean":
                case "bool":
                    var value = true;

                    if (
                        !item.value ||
                        item.value === "false" ||
                        item.value === "0" ||
                        item.value === "null" ||
                        item.value === "undefined"
                    ) {
                        value = false;
                    }

                    item.value = value;
                    break;
            }

            next_level(returnArray, item.name, item.value);
        }
        return returnArray;
    };
    var next_level = function(object, path, value) {
        var splitted = path.split(".");
        var first = "" + splitted.splice(0, 1)[0];
        var array_split = first.match(/\[(\d+)]/g);

        if (array_split) {
            var array_item = array_split[0];
            var array_index = array_item.substring(1, array_item.length - 1);

            array_index = parseInt(array_index);
            first = first.replace(array_item, "");

            if (!object[first]) {
                object[first] = [];
            }
            if (splitted.length === 0) {
                object[first][array_index] = value;

                return;
            }

            if (!object[first][array_index]) {
                object[first][array_index] = {};
            }

            next_level(object[first][array_index], splitted.join("."), value);

            return;
        }

        if (splitted.length === 0) {
            if (first.endsWith("[]")) {
                //nazwa kończy się na [] więc zapisujemy jako array
                first = first.substring(0, first.lastIndexOf("[]"));
                if (!$.isArray(object[first])) {
                    object[first] = [];
                }
                object[first].push(value);
            } else if (object[first]) {
                //nazwa jest powtórzona więc poprzednią wartość zapisujemy do array
                if (!$.isArray(object[first])) {
                    object[first] = [object[first]];
                }
                object[first].push(value);
            } else {
                //zwykła wartość
                object[first] = value;
            }
        } else {
            if (!object[first]) {
                object[first] = {};
            }

            next_level(object[first], splitted.join("."), value);
        }
    };
})(jQuery);
